// ComplexOrderFooter.tsx
import React from "react";
import { useTheme } from "../../../hooks/useTheme";
import Button from "../../button/Button";
import styles from "./ComplexOrderFooter.module.scss";

interface ComplexOrderFooterProps {
  phone: string;
  comment: string;
  onPhoneChange: (value: string) => void;
  onCommentChange: (value: string) => void;
  onSend: () => void;
  disabled: boolean;
  loading: boolean;
  maxCommentLength?: number;
  onBack?: () => void;
  error?: string | null;
}

export default function ComplexOrderFooter({
  phone,
  comment,
  onPhoneChange,
  onCommentChange,
  onSend,
  disabled,
  loading,
  maxCommentLength = 500,
  onBack,
  error,
}: ComplexOrderFooterProps) {
  const { theme } = useTheme();

  return (
    <div className={styles.container}>
      <div className={styles.fields}>
        <div className={styles.fieldItem}>
          <label
            className={styles.label}
            style={{ color: theme.textSecondary }}
          >
            Телефон <span style={{ color: theme.danger }}>*</span>
          </label>
          <input
            type="tel"
            className={styles.input}
            value={phone}
            onChange={(e) => onPhoneChange(e.target.value)}
            placeholder="+7 (999) 123-45-67"
            style={{
              backgroundColor: theme.background,
              color: theme.text,
              borderColor: theme.border,
            }}
          />
        </div>

        <div className={styles.fieldItem}>
          <label
            className={styles.label}
            style={{ color: theme.textSecondary }}
          >
            Комментарий
          </label>
          <textarea
            className={styles.textarea}
            value={comment}
            onChange={(e) => {
              if (e.target.value.length <= maxCommentLength) {
                onCommentChange(e.target.value);
              }
            }}
            placeholder="Опишите ваш проект"
            rows={3}
            maxLength={maxCommentLength}
            style={{
              backgroundColor: theme.background,
              color: theme.text,
              borderColor: theme.border,
            }}
          />
          <span
            className={styles.charCount}
            style={{ color: theme.textSecondary }}
          >
            {comment.length}/{maxCommentLength}
          </span>
        </div>
      </div>

      {/* 👇 ОШИБКА С ЗАЩИТОЙ ДЛЯ МОБИЛЬНОЙ ВЕРСИИ */}
      {error && (
        <div
          className={styles.errorContainer}
          style={{
            backgroundColor: theme.danger
              ? `${theme.danger}15`
              : "rgba(255, 59, 48, 0.08)",
            borderColor: theme.danger
              ? `${theme.danger}30`
              : "rgba(255, 59, 48, 0.2)",
            color: theme.danger || "#FF3B30",
          }}
        >
          {error}
        </div>
      )}

      <div className={styles.buttonWrapper}>
        {onBack && (
          <Button
            title="Назад"
            onClick={onBack}
            variant="secondary"
            fullWidth
          />
        )}
        <Button
          title="Отправить заявку"
          onClick={onSend}
          variant="primary"
          disabled={disabled || !!error}
          loading={loading}
          fullWidth
        />
      </div>
    </div>
  );
}
